module.exports = __webpack_public_path__ + "img/plyr-enter-fullscreen.858dced3.svg";